import { Localidad, Provincia } from "../../../services/gob-ar"

export enum ActionType {
    SET_PROVINCES = 'setProvinces',
    SET_LOCALITIES = 'setLocalities'
}

interface SetProvinces {
    type: ActionType.SET_PROVINCES
    payload: Provincia[]
}

interface SetLocalities {
    type: ActionType.SET_LOCALITIES
    payload: Localidad[]
}

export type CommonAction =
    SetProvinces |
    SetLocalities
